export const ButtonBack = {
  transclude: true,

  bindings: {
    onClick: '&',
  },

  template: `
    <button class="btn btn-link p-0"
      type="button"
      ng-click="$ctrl.onClickBack()">
      <i class="fa fa-chevron-left"></i>
      <ng-transclude>Back</ng-transclude>
    </button>`,

  controller($window) {
    'ngInject';

    return {
      onClickBack() {
        if (this.onClick() === undefined) {
          $window.history.back();
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Button/ButtonBack.js